import React, {Component} from 'react';
import {Route, Switch} from 'react-router-dom';
import {Cobranzas} from "./cobranzas/cobranzas";
import {MainContext} from "contexts/main.context";

const basePath = '/ventas/recepciones';

export class Recepciones extends Component {
    render() {
        return (
            <>
                <Switch>
                    <Route path={`${basePath}/`} component={Cobranzas}/>
                </Switch>
            </>
        )
    }
}

Recepciones.contextType = MainContext;
